export default "__VITE_ASSET__8ce86f62__";